import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../Components/PrimeReact/logo";
import DisclosureScroller from "../../Components/TextScroller/disclosureScoller";
import { DateTimer } from "../../Components/Timer/dateTimer";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { retrieveStockScreen3, retrieveStockScreen3Data, retrieveStockSession } from "../../Services/StockSessionApiService";
import { retrieveIndexHistory } from "../../Services/IndexApiService";
import HistoryIndexChart from "../../Components/HistoryIndex/history-index";
import { useAuthHeader, useSignOut } from "../../auth/AuthService";
import { useNavigate } from "react-router-dom";
import IndexSummaryDataDisplay from "../../Components/PrimeReact/MarketSummary/indexSummaryDataDisplay";

export default function Screen3P() {
    const {t, i18n} = useTranslation();
    const [ROTATE, setROTATE] = useState(false);
    const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 3)));
    const [endDate, setEndDate] = useState(new Date());
    const [price , setPrice] = useState([]);
    const [volume, setVolume] = useState([]);
    const [data, setData] = useState([]);
    const authHeader = useAuthHeader();
    const [lang, setLang] = useState();
    const signOut = useSignOut();
    const navigator = useNavigate();

    const logoutFunction = () => {
        if (signOut()) {
            navigator('/login');
        }
    }

    var START = 1;
    var MARKET_CLOSING = 99;
    const [STATE, setSTATE] = useState(START);

    async function updateStockData() {
        await retrieveStockScreen3Data('', authHeader())
        .then((response) => {
            let data = response.data.data;
            let dataArr = [];
            dataArr[0] = data?.mainBoard;
            dataArr[0]['market'] = "Main Board";
            dataArr[1] = data?.growthBoard;
            dataArr[1]['market'] = "Growth Board";
            setData(dataArr);
        })
        .catch((error) => {
            if (error.response.status === 403) {
                logoutFunction();
            }
        });
        check()
    }

    async function getHistoryDate() {
        await retrieveIndexHistory(startDate, endDate, authHeader())
        .then((response) => {
            let data = response.data.data;
            let price = [];
            let volume = [];
            data.map((v) => {
                v[0] = (new Date(v[0])).getTime();
                if (v[6] == 2) {
                    v[1] = v[2] = v[3] = v[4];
                }
                price.push([
                    v[0],
                    v[4]
                ]);
                volume.push([v[0], v[5]]);
            });
            setPrice(price);
            setVolume(volume);
        })
        .catch((error) => {
            if (error.response.status === 403) {
                logoutFunction();
            }
        });
    }

    async function check() {
        await retrieveStockSession(authHeader())
        .then((response) => {
            response.data.data.session && setSTATE(MARKET_CLOSING);
        })
        .catch((error) => {
            if (error.response.status === 403) {
                logoutFunction();
            }
        });
    }

    async function init() {
        let data;
        await retrieveStockScreen3('', authHeader())
        .then((response) => {
            data = response.data.data;
            let lang = data?.language == "cat" ? "kh" : "en";
            setLang(lang);
            i18n.changeLanguage(lang);
        })
        .catch(error => {
            if (error.response.status === 403) {
                logoutFunction();
            }
        });
        return data;
    }

    useEffect(() => {
        updateStockData();
        getHistoryDate();

        const dataInterval = setInterval(updateStockData, 5000);

        if (STATE == MARKET_CLOSING || (new Date().setHours(15,10,0)) < (new Date().getTime())) {
            clearInterval(dataInterval);
        }

        return () => {
            clearInterval(dataInterval);
        }
    },[STATE]);

    useEffect(() => {
        let rotateTime = async () => await init();
        var intervalRotate;
        rotateTime().then((e) => {
            // e && (intervalRotate = setInterval(rotateNext, e * 1000))
        });
        return () => {
            clearInterval(intervalRotate);
        }
    },[ROTATE])

    const marketBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-center">
                <span className="font-bold ml-2">{t(rowData?.market)}</span>
            </div>
        );
    }

    const basePriceBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-end">
                <span className="flex">{rowData?.totalVol?.toLocaleString('en-US')}</span>
            </div>
        );
    }

    const expPriceBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-end">
                <span className='flex'>{rowData?.totalVal?.toLocaleString('en-US')}</span>
            </div>
        );
    }

    const expQtyBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-end">
                <span className='flex'>{rowData?.totalMktCap?.toLocaleString('en-US', { maximumFractionDigits: 0})}</span>
            </div>
        );
    }

    const bidBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-end">
                <span className='flex'>{rowData?.totalFullMktCap?.toLocaleString('en-US',  { maximumFractionDigits: 0})}</span>
            </div>
        );
    }

    return (
        <div className='relative md:h-screen'>
            <div className="flex align-items-center h-full">
                <div className="flex justify-content-center shadow-2 h-full bg-screen">
                    <div className='flex w-12 justify-content-center px-3'>
                        <div className="grid w-full">
                            <div className="col-12 text-white">
                                <div className='grid'>
                                    <div className="col-6 lg:col-4 h-6rem md:h-full">
                                        <Logo />
                                    </div>
                                    <IndexSummaryDataDisplay STATE={1}/>
                                    <div className="col-12 lg:col-4 flex align-items-center">
                                        <div className="grid w-full md:text-3xl">
                                            <div className={(i18n.language == 'kh' ? 'py-0' : '' ) +' col-12 flex justify-content-end'}>
                                                <DateTimer type={1}/>
                                            </div>
                                            <div className={(i18n.language == 'kh' ? 'py-0' : '' ) +' col-12 flex justify-content-end'}>
                                                {t('Time')}:<DateTimer type={2}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 -mt-6'>
                                <div className="card px-4 py-3 shadow-1 border-round-lg bg-card">
                                    <DataTable value={data} className="text-white w-full" tableClassName="bg-none">
                                        <Column field="esymbol" align="center" header={<span className="text-yellow-600 ">{t('Market')}</span>} body={marketBodyTemplate} className="border-blue-700 text-white text-sm md:text-3xl font-bold" style={{background: 'none'}}></Column>
                                        <Column field="bprice" align="right" header={<span className="text-yellow-600">{t('Total Trading Volume')}</span>}  body={basePriceBodyTemplate} className="border-blue-700 text-white text-sm md:text-3xl font-bold" style={{background: 'none'}}></Column>
                                        <Column field="etprice" align="right" header={<span className="text-yellow-600">{t('Total Trading Value')}</span>}  body={expPriceBodyTemplate} className="border-blue-700 text-white text-sm md:text-3xl font-bold" style={{background: 'none'}}></Column>
                                        <Column field="etquantity" align="right" header={<span className="text-yellow-600">{t('Total Market Cap. (M)')}</span>}  body={expQtyBodyTemplate} className="border-blue-700 text-white text-sm md:text-3xl font-bold" style={{background: 'none'}}></Column>
                                        <Column field="fsbpqprice" align="right" header={<span className="text-yellow-600">{t('Total Full Market Cap. (M)')}</span>}  body={bidBodyTemplate} className="border-blue-700 text-white text-sm md:text-3xl font-bold" style={{background: 'none'}}></Column>
                                    </DataTable>
                                </div>
                            </div>

                            <div className="col-12 -mt-6">
                                <HistoryIndexChart
                                    price={price}
                                    volume={volume}
                                    label = {{'title': t('ICSX'), 'volume': t('Volume') , 'price': t('Index')}}
                                />
                                <div className="text-yellow-500 pt-3 font-bold text-sm">{t('Trading Volume Remark')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="grid py-1 shadow-2 w-full absolute bottom-0 bg-card">
                <div className="py-0 col-12">
                    {lang && <DisclosureScroller />}
                </div>
            </div>
        </div>
    )
}
